import React from "react";
import { useLang } from "@/context/LanguageContext";

function FlagIT({ className = "" }) {
    return (
        <svg className={className} viewBox="0 0 3 2" aria-label="Italiano">
            <rect width="1" height="2" x="0" fill="#008C45" />
            <rect width="1" height="2" x="1" fill="#F4F5F0" />
            <rect width="1" height="2" x="2" fill="#CD212A" />
        </svg>
    );
}

function FlagGB({ className = "" }) {
    return (
        <svg className={className} viewBox="0 0 60 30" aria-label="English">
            <clipPath id="uk-clip"><path d="M0,0 v30 h60 v-30 z" /></clipPath>
            <rect width="60" height="30" fill="#012169" />
            <g clipPath="url(#uk-clip)">
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="3" clipPath="url(#uk-clip)" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    );
}

export default function LanguageSwitcher({ className = "" }) {
    const { lang, setLang } = useLang();
    return (
        <div data-testid="language-switcher" className={`inline-flex items-center gap-1 ${className}`}>
            <button
                type="button"
                onClick={() => setLang("it")}
                aria-label="Italiano"
                data-testid="lang-it"
                className={`w-7 h-5 border overflow-hidden transition-all ${lang === "it" ? "border-abnormal-acid ring-1 ring-abnormal-red" : "border-white/20 hover:border-white/60 opacity-70 hover:opacity-100"}`}
            >
                <FlagIT className="w-full h-full block" />
            </button>
            <button
                type="button"
                onClick={() => setLang("en")}
                aria-label="English"
                data-testid="lang-en"
                className={`w-7 h-5 border overflow-hidden transition-all ${lang === "en" ? "border-abnormal-acid ring-1 ring-abnormal-red" : "border-white/20 hover:border-white/60 opacity-70 hover:opacity-100"}`}
            >
                <FlagGB className="w-full h-full block" />
            </button>
        </div>
    );
}
